<div class="card">
    <div class="card-body">
        <div class="row mb-2">
            <div class="col-6">
                <h5 class="mt-0 mb-2">
                    Certificaciones
                </h5>
            </div>
            <div class="col-6">
                <div class="text-end">
                    <button type="button" (click)="add()" class="btn btn-outline-primary btn-sm" data-bs-toggle="modal"
                        data-bs-target="#modalCertificacion">
                        <i class="fa-regular fa-square-plus"></i>
                        Nuevo
                    </button>
                </div>
            </div>
        </div>
        <div class="table-responsive mb-2">
            <table class="table table-hover table-theme">
                <thead>
                    <tr>
                        <th>Institución</th>
                        <th>Certificación</th>
                        <th>Fecha de obtención</th>
                        <th>Fecha de expiración</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of certifications(); let index = $index; track $index) {
                    <tr>
                        <td class="text-left">{{item.institution}}</td>
                        <td class="text-left">{{item.name}}</td>
                        <td class="text-left">{{item.completionDate | date : 'dd/MM/yyyy'}}</td>
                        <td class="text-left">
                            @if (item.expirationDate) {
                                {{item.expirationDate | date : 'dd/MM/yyyy'}}
                            }@else {
                                N/A
                            }
                        </td>
                        <td class="text-center">
                            <button (click)="editResumeCertification(item, index)" type="button"
                                class="btn btn-outline-success me-2" data-bs-toggle="modal"
                                data-bs-target="#modalCertificacion">
                                <i class="fa-solid fa-pen-to-square"></i>
                            </button>
                            <button (click)="deleteResumeCertification(item, index)" type="button"
                                class="btn btn-outline-danger">
                                <i class="fa-regular fa-trash-can"></i>
                            </button>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>

<app-modal-certification 
[resumeId]="resumeId()"
(onResumeCertification)="handlerResumeCertification($event)"/>